import { keyValueList } from "../../../fable_modules/fable-library-js.4.19.0/MapUtil.js";
import { map, toArray, empty, singleton, append } from "../../../fable_modules/fable-library-js.4.19.0/List.js";
import { Types_RequestProperties } from "../../../fable_modules/Fable.Fetch.2.7.0/Fetch.fs.js";
import { Auto_generateBoxedDecoderCached_Z6670B51 } from "../../../fable_modules/Thoth.Json.10.4.1/./Decode.fs.js";
import { Banner_Banner_$reflection } from "../../../../Bfs.Web.Data.Service.Contracts/Kundenportal.Contracts.fs.js";
import { union_type, class_type, record_type, lambda_type, unit_type, list_type } from "../../../fable_modules/fable-library-js.4.19.0/Reflection.js";
import { CaseStrategy } from "../../../fable_modules/Thoth.Json.10.4.1/Types.fs.js";
import { errorString, Encoders } from "../../../../Bfs.Web.Portale/./Http.fs.js";
import { fromString } from "../../../../Bfs.Web.Portale/../Bfs.Web.Kundenportal/fable_modules/Thoth.Json.10.4.1/Decode.fs.js";
import { int32ToString, uncurry2 } from "../../../fable_modules/fable-library-js.4.19.0/Util.js";
import { Union, Record } from "../../../fable_modules/fable-library-js.4.19.0/Types.js";
import { GlobalMsg_$reflection } from "../../../../Bfs.Web.Portale/Types.fs.js";
import { FSharpResult$2 } from "../../../fable_modules/fable-library-js.4.19.0/Result.js";
import { Cmd_none } from "../../../fable_modules/Fable.Elmish.4.2.0/cmd.fs.js";
import { value, some } from "../../../fable_modules/fable-library-js.4.19.0/Option.js";
import { request } from "../../../../Bfs.Web.Portale/Http.fs.js";
import { FunctionComponentPreparedRenderFunctionCache_GetOrAdd_3560CE5E } from "../../../fable_modules/Fable.React.9.4.0/./Fable.React.FunctionComponent.fs.js";
import { BannerProps, PreviewMode, bfsBanner } from "../Shared/Banner.fs.js";
import { Markdown_ToHtml_1BFEAEDB } from "../../../fable_modules/Fable.Formatting.Markdown.1.0.1/Markdown.fs.js";
import * as react from "react";
import { React_useElmish_Z6C327F2E } from "../../../fable_modules/Fable.React.UseElmish.1.0.0-beta-001/./Fable.React.UseElmish.fs.js";
import { ProgramModule_mkProgram } from "../../../fable_modules/Fable.React.UseElmish.1.0.0-beta-001/../Fable.Elmish.4.2.0/program.fs.js";

export function Http_loadBanner() {
    const response = fetch("api/banner", keyValueList(append(singleton(new Types_RequestProperties(4, ["include"])), empty()), 1));
    const decoder = Auto_generateBoxedDecoderCached_Z6670B51(list_type(Banner_Banner_$reflection()), new CaseStrategy(1, []), Encoders());
    return response.then((response_1_1) => {
        if (!(response_1_1.ok)) {
            throw new Error(errorString(response_1_1));
        }
        else {
            const pr = response_1_1.text();
            return pr.then((res) => {
                const matchValue = fromString(uncurry2(decoder), res);
                if (matchValue.tag === 1) {
                    throw new Error(matchValue.fields[0]);
                }
                else {
                    return matchValue.fields[0];
                }
            });
        }
    });
}

export class Model extends Record {
    constructor(GlobalDispatch, Banner) {
        super();
        this.GlobalDispatch = GlobalDispatch;
        this.Banner = Banner;
    }
}

export function Model_$reflection() {
    return record_type("Bfs.Web.Kundenportal.WebParts.User.Dashboard.Banner.Model", [], Model, () => [["GlobalDispatch", lambda_type(GlobalMsg_$reflection(), unit_type)], ["Banner", list_type(Banner_Banner_$reflection())]]);
}

export class Msg extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["LoadBanner", "LoadBannerCompleted"];
    }
}

export function Msg_$reflection() {
    return union_type("Bfs.Web.Kundenportal.WebParts.User.Dashboard.Banner.Msg", [], Msg, () => [[], [["Item", union_type("Microsoft.FSharp.Core.FSharpResult`2", [list_type(Banner_Banner_$reflection()), class_type("System.Exception")], FSharpResult$2, () => [[["ResultValue", list_type(Banner_Banner_$reflection())]], [["ErrorValue", class_type("System.Exception")]]])]]]);
}

export function State_init(globalDispatch) {
    return [new Model(globalDispatch, empty()), singleton((dispatch) => {
        dispatch(new Msg(0, []));
    })];
}

export function State_update(msg, model) {
    if (msg.tag === 1) {
        if (msg.fields[0].tag === 0) {
            return [new Model(model.GlobalDispatch, msg.fields[0].fields[0]), Cmd_none()];
        }
        else {
            console.error(some(msg.fields[0].fields[0]));
            return [model, Cmd_none()];
        }
    }
    else {
        return [model, request(Http_loadBanner, undefined, (Item) => (new Msg(1, [Item])))];
    }
}

export const Bannerlist = FunctionComponentPreparedRenderFunctionCache_GetOrAdd_3560CE5E((((value("C:\\BuildAgent\\work\\c238671ccc1e7da2\\BfsKundenportal\\src\\Bfs.Web.Kundenportal\\WebParts\\User\\Dashboard\\Banner.fs") + "#L") + int32ToString(value(43))) + ";") + "System.Tuple`3[Microsoft.FSharp.Core.FSharpFunc`2[Types.GlobalMsg,Microsoft.FSharp.Core.Unit],Microsoft.FSharp.Core.FSharpFunc`2[System.Object,Microsoft.FSharp.Core.Unit],Microsoft.FSharp.Core.FSharpOption`1[Types.UserSession]]", value("Bannerlist"), (tupledArg) => {
    let init;
    const globalDispatch = tupledArg[0];
    return toArray(map((banner) => {
        const children = [bfsBanner(new BannerProps(globalDispatch, tupledArg[1], tupledArg[2], banner.Id, banner.Tag, banner.Titel, Markdown_ToHtml_1BFEAEDB(banner.Text), banner.HasImageDesktop, banner.HasImageMobile, (banner.ImageOnly && banner.HasImageDesktop) && banner.HasImageMobile, banner.HintergrundFarbe, banner.TextFarbe, 0, new PreviewMode(0, [])))];
        return react.createElement("div", {
            key: banner.Id,
        }, ...children);
    }, ((init = State_init(globalDispatch), React_useElmish_Z6C327F2E(() => ProgramModule_mkProgram(() => init, State_update, (_arg, _arg_1) => {
    }), undefined, undefined)))[0].Banner));
}, undefined, undefined, "Of");

//# sourceMappingURL=Banner.fs.js.map
